import {
  AS_SET_LOADING,
  AS_SET_ERROR,
  AS_SET_SKILLS,
  AS_SET_CURRENT_SKILL,
  AS_ADD_SKILL,
  AS_UPDATE_SKILL,
  AS_REMOVE_SKILL,
  AS_SET_SEARCH_RESULTS,
  AS_RESET,
} from "./aiSkillTypes";

const initialState = {
  loading: false,
  error: null,
  skills: [],
  currentSkill: null,
  searchResults: [],
};

export const aiSkillReducer = (state = initialState, action) => {
  switch (action.type) {
    case AS_SET_LOADING:
      return { ...state, loading: action.payload, error: null };
    case AS_SET_ERROR:
      return { ...state, error: action.payload, loading: false };

    case AS_SET_SKILLS:
      return { ...state, skills: action.payload };
    case AS_SET_CURRENT_SKILL:
      return { ...state, currentSkill: action.payload };
    case AS_ADD_SKILL:
      return { ...state, skills: [action.payload, ...state.skills] };
    case AS_UPDATE_SKILL:
      return {
        ...state,
        skills: state.skills.map((s) =>
          s._id === action.payload._id ? { ...s, ...action.payload } : s
        ),
        currentSkill:
          state.currentSkill?._id === action.payload._id
            ? { ...state.currentSkill, ...action.payload }
            : state.currentSkill,
      };
    case AS_REMOVE_SKILL:
      return {
        ...state,
        skills: state.skills.filter((s) => s._id !== action.payload),
        currentSkill:
          state.currentSkill?._id === action.payload ? null : state.currentSkill,
      };
    case AS_SET_SEARCH_RESULTS:
      return { ...state, searchResults: action.payload };

    case AS_RESET:
      return initialState;

    default:
      return state;
  }
};
